<template>
  <div class="dialog-mask" @click.self="handleClickOutside">
    <div class="dialog-content">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<{}, Methods, {}, Props>({
  props: {
    onClickOutside: {
      type: Function,
      required: true,
    },
  },

  methods: {
    handleClickOutside() {
      this.onClickOutside();
    },
  },

  mounted() {
    // 背景のスクロールを無効化
    document.body.style.overflow = "hidden";
  },

  beforeDestroy() {
    // 背景のスクロールを有効化
    document.body.style.overflow = "";
  },
});

interface Methods {
  handleClickOutside: () => void;
}

interface Props {
  onClickOutside: () => void;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-content {
  margin: 0 20px;
  padding: 20px 20px 0 20px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-md);
  color: var(--color-text-normal);
  max-width: 350px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

@media (max-width: 576px) {
  .dialog-content {
    margin: 0 15px;
    padding: 15px 15px 0 15px;
  }
}
</style>

